import type { IAttributeRegistry } from '@commenda/types';
import type { KeyPersonRoleType } from './types';

// Display order. DIRECTOR stays here for read surfaces (e.g. the role filter); the assign wizard omits it
// because Director is offered as a governance-role option.
export const ROLE_ORDER: KeyPersonRoleType[] = [
  'GOVERNANCE',
  'OFFICER',
  'DIRECTOR',
  'UBO',
  'AUTHORIZED_SIGNATORY',
];

// Shown only until the registry loads (or if an attribute is missing) — the backend registry is authoritative.
const LOADING_FALLBACK_LABEL: Record<KeyPersonRoleType, string> = {
  DIRECTOR: 'Director',
  OFFICER: 'Officer',
  GOVERNANCE: 'Governance',
  AUTHORIZED_SIGNATORY: 'Authorized Signatory',
  UBO: 'UBO',
};

export const roleLabel = (
  registry: IAttributeRegistry | undefined,
  roleKey: string
): string =>
  registry?.attributes.find((attribute) => attribute.key === roleKey)?.label ??
  LOADING_FALLBACK_LABEL[roleKey as KeyPersonRoleType] ??
  roleKey;
